module.exports = __webpack_public_path__ + "img/¥0.15_sm.ecad1bb0.png";